// ivux样式
import 'ivux/src/styles/index.less'
import './component.less'
// ajax拦截
import axiosWatcher from '@/utils/axios-watcher'
// ivux i18n
import locale from 'ivux/src/locale'
// 组件
import {
    Avatar,
    Badge,
    Breadcrumb,
    BreadcrumbItem,
    Card,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Row,
    Col,
    Button,
    Layout,
    Header,
    Footer,
    Content,
    Sider,
    Scroll,
    Submenu,
    Menu,
    MenuItem,
    CommonIcon,
    Icon,
    Poptip,
    PoptipButton,
    LoadingBar,
    Message,
    Modal,
    SmartModal,
    Notice,
    Spin,
    Tooltip,
    Progress,
    Upload,
    Tag,
    Tabs,
    TabPane,
    // form
    BaseInput,
    Form,
    FormItem,
    FormCheckList,
    FormLookup,
    Input,
    InputNumber,
    DatePicker,
    Select,
    SelectTree,
    Option,
    Radio,
    RadioGroup,
    Checkbox,
    CheckboxGroup,
    Switch,
    // table
    Table,
    Tree,
    TreeTable,
    TableSearcher,
    TablePager,
    TableToolBar,
    Collapse,
    Panel,
    CheckTag,
    CheckTagGroup
} from 'ivux'
import BaseImg from '_c/base-img'
import componentMsgZhCn from 'ivux/src/locale/lang/zh-CN'
import noData from '@/assets/images/no-data.png'

export default function(Vue, options = {}) {
    var {
        i18n,
        config
    } = options
    // ivew组件考虑了国际化并mixin了翻译函数t以及翻译本文，但是t本身不具备翻译功能，它是一个开放的函数接口
    // 默认实现是,使用vuei18n的翻译函数$t，但是这个默认实现有bug
    // 它用Object.getPrototype(vm || Vue).$t来获取$t，vm的原型就是Vue,而调用Vue.$t会报错（这个也许是vuei18n的版本兼容问题，本项目是7.x）
    // 因此重写这个接口，保证其使用正确的i18n实例翻译函数
    if (i18n) {
        locale.i18n((key, value) => i18n.t(key, value))
        i18n.mergeLocaleMessage(Vue.config.lang, componentMsgZhCn)
    }

    // 图标默认值设置
    CommonIcon.defaults.fontClass = config.icon.fontClass
    CommonIcon.defaults.baseType = config.icon.baseType

    // 表格组件空提示
    Table.defaults.noDataImg = noData
    Table.defaults.noDataText = null
    TreeTable.defaults.noDataImg = noData
    TreeTable.defaults.noDataText = null

    // 全局实例
    Vue.prototype.$Loading = LoadingBar;
    Vue.prototype.$Message = Message;
    Vue.prototype.$Modal = Modal;
    Vue.prototype.$Notice = Notice;
    Vue.prototype.$Spin = Spin;

    // global components
    var components = {
        Avatar,
        Badge,
        Breadcrumb,
        BreadcrumbItem,
        Card,
        Dropdown,
        DropdownMenu,
        DropdownItem,
        Row,
        Col,
        Button,
        Layout,
        Header,
        Footer,
        Content,
        Sider,
        Scroll,
        Submenu,
        Menu,
        MenuItem,
        CommonIcon,
        Icon,
        Poptip,
        PoptipButton,
        LoadingBar,
        Message,
        Modal,
        SmartModal,
        Notice,
        Spin,
        Tooltip,
        Progress,
        Upload,
        Tag,
        Tabs,
        TabPane,
        // form
        BaseInput,
        Form,
        FormItem,
        FormCheckList,
        FormLookup,
        Input,
        InputNumber: Vue.extend(InputNumber).extend({
            props: {
                placeholder: {
                    type: String,
                    default: '0.00'
                },
            }
        }),
        DatePicker,
        Select,
        SelectTree,
        Option,
        Radio,
        RadioGroup,
        Checkbox,
        CheckboxGroup,
        iSwitch: Switch,
        // table
        Table,
        Tree,
        TreeTable,
        TableSearcher,
        TablePager,
        TableToolBar,
        Collapse,
        Panel,
        CheckTag,
        CheckTagGroup,
        // proj
        BaseImg,
    }

    for (var c in components) {
        Vue.component(c, components[c])
    }

    // 登录失效，给出提示
    axiosWatcher.$on("sessionLost", () => {
        Message.error('登录失效，请重新登录')
    })

    // ajax失败，统一错误提示
    axiosWatcher.$on("requestDone", res => {
        var status = res.status + ''

        if (status != 200 && status.startsWith('5')) {
            Message.error('服务内部错误')
        }

        var data = res.data 
        if (status == 200 && data.code != 200) {
            if (data.code !== 403 && data.msg) {
                Message.error(data.msg)
            }
        }
    })
}